<template>
	<Carousel
		ref="badgeCarouselRef"
		class="relative h-auto w-full"
		:plugins="[WheelGesturesPlugin()]"
		:opts="{
			loop: false,
			align: 'center',
			dragFree: true,
			containScroll: 'keepSnaps'
		}"
	>
		<CarouselContent class="h-full">
			<CarouselItem
				v-for="(region, index) in regions"
				:key="region.title"
				class="pointer-events-none relative w-auto basis-auto"
				:class="{
					'ml-4 md:ml-6': index === 0,
					'mr-4 md:mr-6': index === regions.length - 1,
					'ml-2': index > 0
				}"
			>
				<Badge
					class="pointer-events-auto h-[32px] w-auto cursor-pointer px-2 font-sans text-sm font-medium tracking-wide transition-colors hover:bg-white hover:text-primary"
					:variant="carouselItemIndex === index ? 'white' : 'white-outline'"
					@click="scrollSlides(index)"
				>
					{{ region.title }}
				</Badge>
			</CarouselItem>
		</CarouselContent>
	</Carousel>
</template>

<script setup lang="ts">
import type Carousel from '@/components/ui/carousel/Carousel.vue';

import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';

interface Region {
	title: string;
}

const emit = defineEmits<{
	(e: 'scrollSlide', value: number): void;
}>();

const props = defineProps<{
	regions: Region[];
	carouselItemIndex: number;
	parentCarouselItemIndex: number;
}>();

const badgeCarouselRef = ref<InstanceType<typeof Carousel> | null>(null);
const { scrollTo } = useCarouselControl({
	carouselContainerRef: badgeCarouselRef,
	cyclic: true
});

watch(
	() => props.parentCarouselItemIndex,
	(index: number) => {
		scrollTo(index, false);
	}
);

function scrollSlides(index: number) {
	emit('scrollSlide', index);
}
</script>
